import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { useAuth } from "../../shared/context/AuthContext";
import { loginUser } from "../services/authService";
import Modal from "../../shared/components/Modal";
import ForgotPassword from "../components/ForgotPassword";
import "../styles/Login.css";
import "../../shared/styles/Global.css";
import "react-toastify/dist/ReactToastify.css";
import AppFooter from "../../shared/components/AppFooter";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();
  const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const MAX_ATTEMPTS = 5;
  const BLOCK_DURATION_MINUTES = 5;

  const isBlocked = () => {
    const blockUntil = localStorage.getItem("loginBlockUntil");
    if (!blockUntil) return false;
    return new Date().getTime() < parseInt(blockUntil, 10);
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (isBlocked()) {
      toast.error(
        "Demasiados intentos fallidos. Intentá nuevamente en unos minutos."
      );
      return;
    }

    if (!email || !password) {
      toast.error("Por favor, rellena todos los campos.");
      return;
    }

    if (!emailRegex.test(email)) {
      toast.error(
        "El correo electrónico ingresado no tiene un formato válido."
      );
      return;
    }

    try {
      await loginUser(email, password);
      login();
      localStorage.removeItem("loginAttempts");
      localStorage.removeItem("loginBlockUntil");
      toast.success("Has iniciado sesión correctamente.");

      setTimeout(() => {
        navigate("/account");
      }, 3000);
    } catch (error) {
      let attempts = parseInt(localStorage.getItem("loginAttempts") || "0", 10);
      attempts += 1;
      localStorage.setItem("loginAttempts", attempts);

      if (attempts >= MAX_ATTEMPTS) {
        const blockUntil =
          new Date().getTime() + BLOCK_DURATION_MINUTES * 60 * 1000;
        localStorage.setItem("loginBlockUntil", blockUntil);
        toast.error(
          "Demasiados intentos fallidos. Intentá nuevamente en unos minutos."
        );
      } else {
        toast.error(error.message);
      }
    }
  };

  return (
    <>
      <main className="loginMain">
        <section className="loginSection">
          <div className="presentationContainer">
            <img src="/images/patientManager1.svg" alt="Patient Manager" />
            <p>La plataforma para gestionar pacientes de manera sencilla.</p>
          </div>

          <div className="loginContainer">
            <form onSubmit={handleLogin}>
              <input
                type="email"
                placeholder="Correo electrónico"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <br />
              <input
                type="password"
                placeholder="Contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <br />
              <button type="submit">Iniciar sesión</button>
            </form>

            <p
              className="forgotPasswordLink"
              onClick={() => setIsForgotPasswordOpen(true)}
            >
              ¿Olvidaste tu contraseña?
            </p>

            <p className="registerLink">
              ¿Aún no tienes una cuenta?{" "}
              <span onClick={() => navigate("/register")}>Crea una aquí.</span>
            </p>
          </div>

          <ToastContainer
            position="top-center"
            autoClose={2500}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />

          <Modal
            isOpen={isForgotPasswordOpen}
            onClose={() => setIsForgotPasswordOpen(false)}
          >
            <ForgotPassword onClose={() => setIsForgotPasswordOpen(false)} />
          </Modal>
        </section>
      </main>
      <AppFooter />
    </>
  );
}

export default Login;
